import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {SmallPopover} from 'icsoc-antd-ex';
import UnionTableList from 'Components/union/unionTableList';
import CommonTable from 'Components/common/commonTable';
import IconFont from 'Components/common/iconFont';
import tTalkingSkillActions from 'Actions/systemSetting/talkingSkill';
import sort from 'Utils/sort';
import moment from 'moment';

const columns = (pageStatus, showConfigModal) => [
  {
    title: '序号',
    key: 'key',
    dataIndex: 'key',
    width: 60,
    fixed: 'left',
    render: (text, record, index) => {
      const {pageNum, pageSize} = pageStatus;

      return sort({pageNum, pageSize, index});
    },
  },
  {
    title: '话术名称',
    dataIndex: 'strategyName',
    key: 'strategyName',
    width: '30%',
    render: text => text || '--',
  },
  {
    title: '开场白命中词',
    dataIndex: 'intro',
    key: 'intro',
    width: '25%',
    render: text => text || '--',
  },
  {
    title: 'NLP类型',
    dataIndex: 'nlpType',
    key: 'nlpType',
    render: text => (text === 'yunwen'?'小云':text) || '--',
  },
  {
    title: '更新时间',
    key: 'updateTime',
    dataIndex: 'updateTime',
    width: 200,
    render: text =>
      (text && moment(text).format('YYYY-MM-DD HH:mm:ss')) || '--',
  },
  {
    title: '操作',
    dataIndex: 'operate',
    key: 'operate',
    width: 80,
    fixed: 'right',
    render: (text, record) => {
      const {nlpType = ''} = record || {};
      const isDetailDisable =
        nlpType === 'gz' || nlpType === 'yb' || nlpType === 'sd' || nlpType === 'yunwen'
          ? ' is-disable'
          : '';

      return (
        <div className="operate">
          <SmallPopover type="white" content="配置" className="tooltip">
            <IconFont
              type="icon-robotsetup"
              onClick={() => showConfigModal(record)}
            />
          </SmallPopover>
          <SmallPopover
            type="white"
            content="详情"
            className={`tooltip${isDetailDisable}`}>
            {isDetailDisable === ' is-disable' ? (
              <IconFont type="icon-robotdetails" />
            ) : (
              <a
                href={
                  record.addr.indexOf('http') === -1
                    ? `https://${record.addr}`
                    : record.addr
                }
                // eslint-disable-next-line react/jsx-no-target-blank
                target="_blank"
                rel="noreferrer">
                <IconFont type="icon-robotdetails" />
              </a>
            )}
          </SmallPopover>
        </div>
      );
    },
  },
];

class TableList extends UnionTableList {
  handleConfigAction = record => {
    const {actions, setConfigModalVisible} = this.props;

    actions.setConfigModalData(record);
    setConfigModalVisible();
  };

  render() {
    const {
      tableListData: {data = [], total = 0} = {},
      loading,
      pageStatus,
    } = this.props;

    return (
      <CommonTable
        style={{marginTop: 20}}
        columns={columns(pageStatus, this.handleConfigAction)}
        dataSource={[...data]}
        rowKey="id"
        loading={loading}
        extraHeight={20}
        scroll={{x: 1000}}
        onChange={this.handleTableChange}
        pagination={{
          current: pageStatus.pageNum,
          total: total && parseInt(total, 10),
          pageSize: pageStatus.pageSize,
          showTotal: () => `共 ${total} 条`,
        }}
      />
    );
  }
}

const mapStateToProps = ({systemSettingTalkingSkill}) => ({
  tableListData: systemSettingTalkingSkill.tableListData,
  pageStatus: systemSettingTalkingSkill.pageStatus,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(tTalkingSkillActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TableList);
